import { RICH_TEXT_NODES } from '@plato/shared-util/lexical-config';
import { $getRoot, createEditor, type SerializedEditorState } from 'lexical';

/**
 * Extract plain text from Lexical EditorState.
 */
export function getTextContent(editorState: SerializedEditorState | null | undefined): string | null {
    if (!editorState) {
        return null;
    }

    try {
        const editor = createEditor({
            nodes: RICH_TEXT_NODES,
            onError: (error) => {
                console.error('Lexical text content extraction error:', error);
            },
        });

        // Parse and set the editor state
        const parsedEditorState = editor.parseEditorState(editorState);
        editor.setEditorState(parsedEditorState);

        // Extract plain text using the official $getRoot().getTextContent() method
        let textContent = '';

        editor.read(() => {
            const root = $getRoot();
            textContent = root.getTextContent();
        });

        // Clean up whitespace and return
        const cleanText = textContent.replaceAll(/\s+/g, ' ').trim();
        return cleanText || null;
    } catch (error) {
        console.error('Error extracting text content from Lexical:', error);
        return null;
    }
}
